import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import * as Common from '_common';
import * as Components from '_components';
export function MonitoringSmallRender(component, index) {
    return _jsx(MonitoringSmall, {});
}
export function MonitoringFullRender(component, index) {
    return _jsx(Monitoring, { full: true });
}
export function Monitoring(props) {
    const context = Common.useSpaContext();
    function formatSize(size) {
        let resultSize = size / 1024;
        let unit = 'kB';
        if (resultSize > 1024) {
            resultSize = resultSize / 1024;
            unit = 'MB';
        }
        if (resultSize > 1024) {
            resultSize = resultSize / 1024;
            unit = 'GB';
        }
        return `${Math.round(resultSize * 100) / 100} ${unit}`;
    }
    function getServiceEvents(service) {
        const events = context?.events ? context?.events[service] : null;
        if (!events) {
            return _jsx(_Fragment, { children: "-- none --" });
        }
        return (_jsxs("table", { className: "visible_table", children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", { children: "Created" }), _jsx("th", { children: "Path" }), _jsx("th", { children: "Name" }), _jsx("th", { children: "Parameters" })] }) }), _jsx("tbody", { children: Object.keys(events)
                        .sort()
                        .reverse()
                        .map((key) => {
                        const event = JSON.parse(events[key]);
                        return (_jsxs("tr", { children: [_jsx("td", { children: event.Created }), _jsx("td", { children: event.Path }), _jsx("td", { children: event.Name }), _jsx("td", { children: JSON.stringify(event.Parameters) })] }, key));
                    }) })] }));
    }
    return Object.keys(context?.monitoring ?? {}).map((key) => {
        const service = context.monitoring[key];
        const details = JSON.parse(service.statusDetails);
        return (_jsxs("div", { children: [_jsx("h1", { children: key }), _jsx(Components.Property, { title: "Status", children: getServiceStatus(service) }), _jsx(Components.Property, { title: "Up time", children: service?.status?.upTime }), _jsx(Components.Property, { title: "PID", children: service?.status?.pid }), _jsx(Components.Property, { title: "Version", children: service?.status?.version }), _jsx("h2", { children: "Events" }), getServiceEvents(key), _jsx("h2", { children: "Services" }), _jsxs("table", { className: "visible_table", children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", { children: "Service" }), _jsx("th", { children: "Last success loop" }), _jsx("th", { children: "Last failed loop" }), _jsx("th", { children: "Fail loop count" })] }) }), _jsx("tbody", { children: Object.keys(details.Services ?? {}).map((key) => {
                                const service = details.Services[key];
                                return (_jsxs(React.Fragment, { children: [_jsxs("tr", { children: [_jsx("td", { children: key }), _jsx("td", { children: service.LastSuccessLoop }), _jsx("td", { children: service.LastFailedLoop ?? '-' }), _jsx("td", { children: service.FailLoopCount })] }, key), service.LastErrorMessage && (_jsx("tr", { children: _jsx("td", { colSpan: 4, children: _jsx("pre", { children: service.LastErrorMessage }) }) }))] }, key));
                            }) })] }), _jsx("h2", { children: "Queues" }), _jsxs("table", { className: "visible_table", children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", { children: "Queue" }), _jsx("th", { children: "Item Count" })] }) }), _jsx("tbody", { children: (details.Queues ?? []).map((queue) => (_jsxs("tr", { children: [_jsx("td", { children: queue.Name }), _jsx("td", { children: queue.Count })] }, queue.Name))) })] }), _jsx("h2", { children: "File system" }), _jsx("table", { className: "visible_table", children: _jsx("tbody", { children: (details.Drives ?? []).map((drive) => (_jsxs("tr", { children: [_jsx("td", { children: drive.Name }), !drive.Size || drive.Size === 0 ? (_jsxs("td", { children: ["n/a", _jsx(Components.Property, { title: "Type", children: drive.DriveType })] })) : (_jsxs("td", { style: { minWidth: '150px' }, children: [_jsx(Components.Progress, { decoration: Components.ProgressBarDecoration.Value, max: drive.Size, value: drive.Size - drive.FreeSpace, valueText: formatSize(drive.Size - drive.FreeSpace) }), _jsx(Components.Property, { title: "Size", children: formatSize(drive.Size) }), _jsx(Components.Property, { title: "Free", children: formatSize(drive.FreeSpace) }), _jsx(Components.Property, { title: "Type", children: drive.DriveType })] }))] }, drive.Name))) }) })] }, key));
    });
}
function getServiceStatus(service) {
    if (!service?.status) {
        return 'unknown';
    }
    const treashold = Date.now() - 1000 * 20;
    if (Date.parse(service.status.timestamp) < treashold) {
        return 'ok';
    }
    else {
        return 'error';
    }
}
export function MonitoringSmall() {
    const context = Common.useSpaContext();
    const monitoring = context?.monitoring ?? {};
    return (_jsx(_Fragment, { children: Object.keys(monitoring).map((key) => {
            const service = monitoring[key];
            return (_jsx(Components.Property, { title: key, children: getServiceStatus(service) }, key));
        }) }));
}
